/* cspell:ignore Dext */

import { makeFormattedPhysicalAddress } from './physical-address';

type CompanyPhone = { label: string; tel: string; display: string };

export const company = {
  legalName: 'AWP Marine Consultancy Ltd',
  shortName: 'AWP Marine',
  registrationNumber: '7303301',
  registeredAddress: makeFormattedPhysicalAddress({
    line1: '2 The Uplands',
    line2: null,
    city: 'Prenton', // cspell:disable-line
    region: null,
    postcode: 'CH43 9TE',
    country: 'United Kingdom',
  }),
  emails: {
    default: 'admin@awpmarine.com',
    // Published in security.txt, so it gets scraped and spammed; a dedicated alias keeps that
    // noise out of the shared inboxes and lets it be filtered or rerouted freely.
    security: 'security@awpmarine.com',
  },
  phones: [
    // Ordered most-preferred first; `tel` is the value for `tel:` links, `display` is human-readable.
    { label: 'Office', tel: '+441516532485', display: '+44 (0) 151 653 2485' },
    { label: 'Mobile', tel: '+447920808685', display: '+44 (0) 7920 808 685' },
  ] satisfies [CompanyPhone, ...CompanyPhone[]],
  /**
   * The officer whose counter-signature is applied on behalf of the company to issued documents
   * (currently the travel risk assessment PDF). Applied automatically at issue, not hand-signed.
   */
  signatory: {
    name: 'Wyn Price',
    title: 'Director',
  },
};

/** Financial details deliberately exported separately from the public company profile. */
export const companyBilling = {
  vatNumber: 'GB997126475',
  // Bookkeeping mailboxes, blind-copied on every invoice sent to a customer: our own archive and
  // the Dext sales inbox, which files the invoice for the accountant.
  submittedInvoicesEmails: ['submitted@awpmarine.com', 'awpmarine+sales@dext.cc'],
  beneficiary: {
    name: 'AWP MARINE CONSULTANCY LIMITED',
    address: company.registeredAddress.formatted,
  },
  bank: {
    name: 'Revolut',
    iban: 'GB58 REVO 0099 6992 1663 79',
    bic: 'REVOGB21', // cspell:disable-line
    sortCode: '09-99-69',
    accountNumber: '92166379',
  },
};

/**
 * The letterhead block rendered beside the logo on every outbound PDF (invoices, payouts,
 * inspection overviews). Kept in one place so the statutory disclosures stay identical across
 * documents - they are read together by the same clients.
 */
export const companyInfoPdfHeaderLines = [
  company.registeredAddress.line1,
  ...(company.registeredAddress.line2 ? [company.registeredAddress.line2] : []),
  `${company.registeredAddress.city}, ${company.registeredAddress.postcode}`,
  `Company Reg No: ${company.registrationNumber}`,
  ...company.phones.map((phone) => phone.display),
  `VAT Reg No: ${companyBilling.vatNumber}`,
];

export const socials = {
  linkedin: {
    username: 'awp-marine-consultancy-ltd',
    url: 'https://uk.linkedin.com/company/awp-marine-consultancy-ltd',
  },
  instagram: {
    username: 'awpmarineconsultancyltd', // cspell:disable-line
    url: 'https://instagram.com/awpmarineconsultancyltd',
  },
  youtube: {
    username: 'awpmarineconsultancy', // cspell:disable-line
    url: 'https://www.youtube.com/@awpmarineconsultancy',
  },
};

export const mobileApps = {
  apple: {
    name: 'App Store',
    url: 'https://apps.apple.com/app/id6761546562',
  },
  google: {
    name: 'Google Play',
    url: 'https://play.google.com/store/apps/details?id=com.awp.awpapp',
  },
};
